module.exports = __webpack_public_path__ + "static/media/light-switch-off.3132a359.svg";